import { apiFetch, readJson, type GetToken } from '@/lib/api/client'
import type { CreateFeedbackInput, FeedbackCreated } from '@/lib/types/feedback'

/** POST /api/feedback — guests omit getToken. */
export function submitFeedback(
  input: CreateFeedbackInput,
  getToken?: GetToken,
): Promise<FeedbackCreated> {
  return apiFetch('/api/feedback', {
    method: 'POST',
    body: input,
    getToken,
  }).then((response) => readJson<FeedbackCreated>(response))
}
